<div class="grip p-fluid" id="nform">
  <div class="image-row" [ngStyle]="{'display': 'grid', 'justify-items': 'center', 'grid-template-columns': 'repeat(' + url_imagen_cabecera.length + ', 1fr)'}">
      <img *ngFor="let url of url_imagen_cabecera" [src]="url" class="img-logo" alt="Imagen de cabecera" />
  </div>
  <form [formGroup]="registroForm" style="margin-top: 5%;">
    <div *ngFor="let item of formulario" [ngStyle]="{'display': 'grid', 'grid-template-columns': 'repeat(' + item.type.length + ', 1fr)'}">
      <ng-container [ngSwitch]="item.type">
        <div *ngFor="let type of item.type; let i = index" [ngSwitch]="type" >
          <div *ngSwitchCase="'enlace'">
            <a
                [href]="item.parametros[i]?.url"
                [ngStyle]="{
                    'font-weight': item.parametros[i]?.strong ? 'bold' : 'normal',
                    'color': item.parametros[i]?.color || 'inherit',
                    'font-size': item.parametros[i]?.font_size || 'inherit',
                    'margin-top': item.parametros[i]?.margin_top || 0,
                    'margin-left': item.parametros[i]?.margin_left || 0,
                    'margin-right': item.parametros[i]?.margin_right || 0,
                    'margin-bottom': item.parametros[i]?.margin_bottom || 0
                }"
                [ngClass]="{
                    'justify-start': item.parametros[i]?.justify_content === 'start',
                    'justify-center': item.parametros[i]?.justify_content === 'center',
                    'justify-end': item.parametros[i]?.justify_content === 'end'
                }"
                target="_blank"   
                rel="noopener noreferrer" 
            >
                {{ item.headers }}
            </a>
        </div>
          <div *ngSwitchCase="'cabecera'">
            <label [ngStyle]="{
                'font-weight': item.parametros[i]?.strong ? 'bold' : 'normal',
                'color': item.parametros[i]?.color || 'inherit',
                'font-size': item.parametros[i]?.font_size || 'inherit',
                'margin-top': item.parametros[i]?.margin_top || 0,
                'margin-left': item.parametros[i]?.margin_left || 0,
                'margin-right': item.parametros[i]?.margin_right || 0,
                'margin-bottom': item.parametros[i]?.margin_bottom || 0
              }"
              [ngClass]="{
                  'justify-start': item.parametros[i]?.justify_content === 'start',
                  'justify-center': item.parametros[i]?.justify_content === 'center',
                  'justify-end': item.parametros[i]?.justify_content === 'end'
              }">{{ item.headers }}
            </label>
          </div>
          <div *ngSwitchCase="'text'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
                'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
                'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
              }">
              <i [ngClass]="item.parametros[i]?.icon" [ngStyle]="{ 'color': item.parametros[i]?.icon_color || 'inherit' }"></i>
              <input [placeholder]="item.headers[i] || item.headers" [name]="item.fields[i]" type="text" pInputText formControlName="{{ item.fields[i] }}" class="input-text" required>
            </span>
          </div>
          <div *ngSwitchCase="'dropdown'" [ngClass]="{'margen input-dropdown': true, 'horizontal-layout': item.type.length >= 2}">
            <span style="width: 100%; height: 40px;">
              <p-dropdown 
                [options]="item.options" 
                [placeholder]="item.headers[i] || undefined" 
                formControlName="{{ item.fields }}"
                [style]="{'width': '99%'}"
                optionLabel="name" 
                optionValue="name" 
                class="input-dropdown" >
              </p-dropdown>
            </span>
          </div>
          <div *ngSwitchCase="'password'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
              'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
              'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
            }">
              <p-password [toggleMask]="true" [feedback]="false" formControlName="{{ item.fields[i] }}" class="input-text" [placeholder]="item.headers[i]"  
              [ngStyle]="{'--toggle-icon-color': item.parametros[0]?.icon_color || 'inherit'}">
              </p-password>
            </span>
          </div>
          <div *ngSwitchCase="'dni'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
                'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
                'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
              }">
              <i [ngClass]="item.parametros[i]?.icon" [ngStyle]="{ 'color': item.parametros[i]?.icon_color || 'inherit' }"></i>
              <input [placeholder]="item.headers[i] || item.headers" [name]="item.fields[i]" type="text" pInputText formControlName="{{ item.fields[i] }}" class="input-text" required>
            </span>
          </div>
          <div *ngSwitchCase="'telefono'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
                'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
                'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
              }">
              <i [ngClass]="item.parametros[i]?.icon" [ngStyle]="{ 'color': item.parametros[i]?.icon_color || 'inherit' }"></i>
              <input [placeholder]="item.headers[i] || item.headers" [name]="item.fields[i]" type="text" pInputText formControlName="{{ item.fields[i] }}" class="input-text" required>
            </span>
          </div>
          <div *ngSwitchCase="'correo'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
                'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
                'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
              }">
              <i [ngClass]="item.parametros[i]?.icon" [ngStyle]="{ 'color': item.parametros[i]?.icon_color || 'inherit' }"></i>
              <input [placeholder]="item.headers[i] || item.headers" [name]="item.fields[i]" type="text" pInputText formControlName="{{ item.fields[i] }}" class="input-text" required>
            </span>
          </div>
          <div *ngSwitchCase="'codigo_postal'" [ngClass]="{'margen input-text': true, 'horizontal-layout': item.type.length >= 2}" >
            <span style="width: 99%" [ngClass]="{
                'p-input-icon-left': item.parametros[i]?.pos_icon === 'left', 
                'p-input-icon-right': item.parametros[i]?.pos_icon === 'right'
              }">
              <i [ngClass]="item.parametros[i]?.icon" [ngStyle]="{ 'color': item.parametros[i]?.icon_color || 'inherit' }"></i>
              <input [placeholder]="item.headers[i] || item.headers" [name]="item.fields[i]" type="text" pInputText formControlName="{{ item.fields[i] }}" class="input-text" required>
            </span>
          </div>
          <div *ngSwitchCase="'pick'">
            <div *ngIf="item.parametros[i]?.posicion_pick === 'left'" class="flex flex-row flex-wrap">
              <app-pick 
                [font_size_opciones]="item.parametros[i]?.font_size_opciones"
                [opciones]="item.options"
                [numero_seleccionables]="item.parametros[i].numero_seleccionables"
                (valorSeleccionado)="onValorSeleccionado($event, item.fields[i])" 
                class="pick-tres-columnas">
              </app-pick> 
              <label [ngStyle]="{
                                    'font-weight': item.parametros[i]?.strong ? 'bold' : 'normal', 
                                    'font-size': item.parametros[i]?.font_size || 'inherit',
                                    'margin-top': item.parametros[i]?.margin_top || 0,
                                    'margin-left': item.parametros[i]?.margin_left || 0,
                                    'margin-right': item.parametros[i]?.margin_right || 0,
                                    'margin-bottom': item.parametros[i]?.margin_bottom || 0
                                  }">
                {{ item.headers }}
              </label>
            </div>
          
            <div *ngIf="item.parametros[i]?.posicion_pick === 'right'" class="flex flex-row flex-wrap centrar" [ngStyle]="{ 'margin-top': item.parametros[i]?.margin_top || 0 }">
              <label 
              [ngStyle]="{
                            'font-weight': item.parametros[i]?.strong ? 'bold' : 'normal', 
                            'font-size': item.parametros[i]?.font_size || 'inherit',
                            'margin-left': item.parametros[i]?.margin_left || 0,
                            'margin-right': '2%',
                            'margin-bottom': item.parametros[i]?.margin_bottom || 0,
                            'align-item': 'start'
                        }">
                {{ item.headers }}
              </label>
              <app-pick 
                [font_size_opciones]="item.parametros[i]?.font_size_opciones"
                [opciones]="item.options"
                [numero_seleccionables]="item.parametros[i].numero_seleccionables"
                (valorSeleccionado)="onValorSeleccionado($event, item.fields[i])" 
                class="pick-tres-columnas">
              </app-pick>
            </div>
          
            <div *ngIf="item.parametros[i]?.posicion_pick === 'bottom'" class="flex flex-column">
              <label [ngStyle]="{
                                    'font-weight': item.parametros[i]?.strong ? 'bold' : 'normal', 
                                    'font-size': item.parametros[i]?.font_size || 'inherit',
                                    'margin-top': item.parametros[i]?.margin_top || 0,
                                    'margin-left': item.parametros[i]?.margin_left || 0,
                                    'margin-right': item.parametros[i]?.margin_right || 0,
                                    'margin-bottom': item.parametros[i]?.margin_bottom || 0
                                  }">
                {{ item.headers }}
              </label>
              <app-pick 
                [pick_bloqueado]="item.parametros[i]?.input_bloqueado"
                [font_size_opciones]="item.parametros[i]?.font_size_opciones"
                [opciones]="item.options"
                [numero_seleccionables]="item.parametros[i].numero_seleccionables"
                (valorSeleccionado)="onValorSeleccionado($event, item.fields[i])" 
                class="pick-tres-columnas">
              </app-pick>
            </div>
          </div>
          <div *ngSwitchCase="'aceptar-check'" class="checkbox" style="display: flex; justify-content: start;">
            <p-checkbox name="{{ item.fields }}" value="{{ item.fields }}"
                formControlName="{{ item.fields }}" [ngStyle]="{ 'margin-right': '1rem' }"></p-checkbox>
            <label [innerHTML]="item.parametros[i].texto" class="label-check"></label>
          </div>
          <div *ngSwitchCase="'boton-enviar'">
            <button [disabled]="bloquear_envio" pButton pRipple type="submit" label="{{ item.headers }}" class="p-button-success"
              (click)="enviarParametros()" [style.background-color]="item.parametros[i].color"
              [style.border-color]="item.parametros[i]?.color" [ngStyle]="{'margin-top': item.parametros[i]?.margin_top || 0}"></button>
          </div>
        </div>
        </ng-container>
      </div>
  </form>
  <div class="image-row" [ngStyle]="{'display': 'grid', 'justify-items': 'center', 'grid-template-columns': 'repeat(' + url_imagenes_bottom.length + ', 1fr)'}">
    <img *ngFor="let url of url_imagenes_bottom" [src]="url" class="img-logo" alt="Imagen de cabecera" />
</div>
</div>